/*
  Globo（Powerful Form Builder）のフォームに、URL のクエリから初期値を入れる。

  **用途**: レッスンページの体験日程から体験申込フォームへ送るとき、
  レッスン名・会場・日程を入力済みの状態で開く（2026-09-14 MTG で設計した動線）。
  Globo 自身は URL パラメータを読まない（storefront の実装が見るのは `utm_*` のみ）ので、
  こちら側で入れる。

  **書き方**: 項目ごとに接頭辞で挙動が変わる。
    `?gf_<フィールド名>=<値>`  … 入れたうえで**編集できないようにする**
    `?gfx_<フィールド名>=<値>` … 入れるだけ（利用者が直せる）
  フィールド名は Globo が name 属性に出すもの（text-5 / select-2 / datetime など）。

  **編集できないようにする理由**（2026-09-16 福水さん指示）:
  日程一覧から選んだ会場・レッスン・日付は**どの回に申し込んだか**そのものなので、
  フォーム上で書き換えられると申込内容と一覧の表示が食い違う。
  とくに会場は**通知先の振り分けキー**なので、変えられると別の教室へ通知が飛ぶ。

  ⚠ **値は必ず DOM の value セッター経由で入れて input/change を飛ばす**
  ——直接 `el.value = x` だけだとアプリ側の状態と検証が追随しない。

  ⚠ **選択項目は disabled にしない**——disabled の項目は送信に乗らない。
  代わりに**選んだ選択肢以外を disabled にする**（表示も送信もそのままで、変更だけができない）。

  ⚠ **日付は flatpickr が値を持つ**——素の value を入れても描画時に空へ戻されるので
  `setDate()` で入れる。固定は `clickOpens` を切る（readonly だけではカレンダーが開く）。
  flatpickr の初期化はフォーム描画より後になることがあるので、入るまで待ち直す。

  ⚠ フォームは非同期で描画されるので、出てくるまで待つ（最長10秒）。
*/
(function () {
  var q = new URLSearchParams(window.location.search);
  var wants = [];
  q.forEach(function (value, key) {
    if (value === '') return;
    if (key.indexOf('gf_') === 0) wants.push([key.slice(3), value, true]);
    else if (key.indexOf('gfx_') === 0) wants.push([key.slice(4), value, false]);
  });
  if (wants.length === 0) return;

  function put(el, value) {
    var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement
      : el.tagName === 'SELECT' ? window.HTMLSelectElement
      : window.HTMLInputElement;
    var desc = Object.getOwnPropertyDescriptor(proto.prototype, 'value');
    if (desc && desc.set) {
      desc.set.call(el, value);
    } else {
      el.value = value;
    }
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // 値が入っている見た目（ラベルを上へ small にする）をこちらで確定させる。
  // アプリ側は focus/blur を見てこの class を付けるので、
  // 描画の順によっては**値だけ入ってラベルが下りたまま**になり、文字が重なる。
  function shrinkLabel(el) {
    var ctl = el.closest('.globo-form-control');
    if (!ctl) return;
    var label = ctl.querySelector('.globo-label');
    if (label) {
      label.classList.add('gfb__label__filled');
      label.classList.add('gfb__label__shink');
    }
    ctl.setAttribute('data-default-value', el.value || '');
  }

  function lock(el) {
    el.classList.add('is-preset');
    var box = el.closest('.globo-form-input') || el.parentElement;
    if (box) box.classList.add('is-preset-field');

    if (el.tagName === 'SELECT') {
      // 選んだもの以外を選べなくする（disabled にすると送信に乗らないため）
      Array.prototype.forEach.call(el.options, function (o) {
        o.disabled = o.value !== el.value;
      });
      return;
    }
    el.readOnly = true;
    // 日付はカレンダーを外す。`clickOpens` を切るだけでは、
    // アプリ側が作り直したときに元へ戻って開けてしまう
    if (el._flatpickr) {
      el._flatpickr.destroy();
    }
    el.setAttribute('readonly', 'readonly');
    el.setAttribute('tabindex', '-1');
  }

  // アプリがフォームを作り直すことがあるので、固定は掛け直す
  function relock() {
    var root = document.querySelector('.globo-formbuilder');
    if (!root) return;
    wants.forEach(function (pair) {
      if (!pair[2]) return;
      var el = root.querySelector('[name="' + pair[0] + '"]');
      if (!el) return;
      shrinkLabel(el);
      if (el.tagName !== 'SELECT' && el._flatpickr) lock(el);
      else if (el.tagName !== 'SELECT' && !el.readOnly) lock(el);
    });
  }

  var done = {};
  function fill() {
    var root = document.querySelector('.globo-formbuilder');
    if (!root) return false;
    var all = true;
    wants.forEach(function (pair) {
      var name = pair[0];
      if (done[name]) return;
      var el = root.querySelector('[name="' + name + '"]');
      if (!el) { all = false; return; }
      // 日付は flatpickr が値を持つので、素の value を入れても上書きされる
      if (el._flatpickr) {
        el._flatpickr.setDate(pair[1], true);
        if (el.value === '') { all = false; return; }
      } else {
        put(el, pair[1]);
      }
      // 選択項目は、値が選択肢に無ければ入らない（入っていないのに固定すると空欄で固定される）
      if (el.tagName === 'SELECT' && el.value !== pair[1]) {
        done[name] = true;
        return;
      }
      shrinkLabel(el);
      if (pair[2]) lock(el);
      done[name] = true;
    });
    return all;
  }

  if (fill()) return;

  var until = Date.now() + 10000;
  var timer = setInterval(function () {
    if (fill() || Date.now() > until) clearInterval(timer);
  }, 200);

  // 描画のあと少しの間だけ見張る（作り直しで固定が外れるのを拾う）
  var guardUntil = Date.now() + 15000;
  var guard = setInterval(function () {
    relock();
    if (Date.now() > guardUntil) clearInterval(guard);
  }, 500);
})();
